import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet'
import { pageRoutesAuth } from "Components/routing";
import { useLayoutEffect, useState } from "react";
import Loader from "Components/Common/Loader/Loader";
import useMyPrivilege from "Hooks/Privilege/useMyPrivilege";


const Body = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [myPrevList, setMyPrivList] = useState<string[]>([])


    useMyPrivilege((data) => {
        var tempList = data.data.privileges.map(e => e.privilege_key)
        setMyPrivList([...tempList])
    })

    useLayoutEffect(() => {

        if (!myPrevList) return
        var allRoutes = pageRoutesAuth.map(e => e.path)
        if (!allRoutes.includes(location.pathname)) return
        var filteredRoute = pageRoutesAuth.filter((e) => {
            if (e.permission[0] === 'all') {
                return true
            } else {
                for (const prev of e.permission) {
                    if (myPrevList.includes(`manage_${prev}`)) {
                        return true
                    }
                }
                return false
            }
        }).map(e => e.path)

        if (filteredRoute.length > 0 && filteredRoute.includes(location.pathname)) {
            return
        }

        navigate(filteredRoute[0])



    }, [myPrevList, location, navigate])





    return (
        <main className="p-1 px-md-2 px-lg-4 py-3">
            {myPrevList ?
                <Routes>
                    {pageRoutesAuth.filter((e) => {
                        if (e.permission[0] === 'all') {
                            return true
                        } else {
                            for (const prev of e.permission) {
                                if (myPrevList.includes(`manage_${prev}`)) {
                                    return true
                                }
                            }
                            return false
                        }
                    }).map(route => (
                        <Route
                            key={route.path + ''}
                            path={route.path + ''}
                            element={
                                <>
                                    <Helmet title={title(route.title)} />
                                    <route.component />
                                </>
                            }
                        />
                    ))}
                    {/* <Route path="*" element={<PageNotFound />} /> */}
                </Routes> :
                <Loader opened={true} />}
        </main>
    );
}

export default Body;



export const title = (pageTitle: string) => {
    return `${pageTitle} · Everest Billing`
}

// const LoaderComp = ({
//     onLoad,
//     onComplete,
//     children,
// }) => {
//     if (onLoad) {
//         // onLoad(false)
//         onLoad()
//     }

//     useLayoutEffect(() => {
//         if (onComplete) {
//             // onComplete(false)
//             onComplete()
//         }
//     }, [onComplete])

//     return <>{children}</>
// }
